import mainAlgoBG from '../../../assets/images/main-panel.png'
import { DroppableComponent } from './DroppableComponent';
import emptyCondition1 from '../../../assets/images/empty-conditionss.png'
import { useEffect, useState } from 'react';
import { ConditionalComponent } from './ConditionalComponent';
import { mainAlgoCreationPanels } from './AlogPanels';
import { useParams } from 'react-router-dom';

export const AlgoComponent = ({
    algoType, algoIndex, setAlgoData, dndRequest, operatorTypes
}) => {
    const params = useParams()
    const [conditionalOperator, setConditionalOperator] = useState('')
    const getOperator = (id) => mainAlgoCreationPanels.find((panel) => panel.id === id)

    

    useEffect(() => {
        setAlgoData('operator', {
            index: algoIndex,
            operator: conditionalOperator?.title
        })
    }, [conditionalOperator])

    useEffect(() => {
        if(params?.id) {
            let op = algoIndex === 0 ? operatorTypes?.buy : operatorTypes?.sell
            setConditionalOperator(mainAlgoCreationPanels.find((panel) => panel.title === op))
        }
    }, [])

    return (
        <div style={{
            backgroundImage: `url(${mainAlgoBG})`
        }} className={`w-[310px] h-[167px] relative bg-cover`}>
            <DroppableComponent accepts={"conditionalPanel"} callback={(res) => {
                                setConditionalOperator(getOperator(res.id))
            }} classes={`w-[200px] h-[50px] absolute top-[5px] left-[55px] bg-cover`} style={{
                backgroundImage: `url(${emptyCondition1})`
            }}>
                {conditionalOperator !== '' && <ConditionalComponent conditionOperator={conditionalOperator?.title} setAlgoData={setAlgoData} algoIndex={algoIndex} dndRequest={dndRequest} />}            
            </DroppableComponent>

            <div className={`flex absolute top-[67px] left-[35px] text-xs text-white h-[50px] flex-row justify-center items-center gap-[20px]`}>
                {algoType}
                {/* <div className={`bg-white text-black text-sm w-[60px] h-[35px] text-center flex justify-center outline-none pt-[8px] rounded-[10px] overflow-hidden`} contentEditable="true" onKeyUp={(e) => {
                    setAlgoData('shares', {
                        index: algoIndex,
                        shares: Number(e.target.innerHTML)
                    })
                }} onKeyPress={(e) => {
                    if (isNaN(String.fromCharCode(e.which))) e.preventDefault();
                }}>
                    {dndRequest[algoIndex]?.shares > 0 ? dndRequest[algoIndex]?.shares : ''}
                </div> */}
                <input 
                    className={`bg-white text-black text-sm w-[60px] h-[35px] text-center flex justify-center outline-none rounded-[10px] overflow-hidden`} 
                    value={dndRequest[algoIndex]?.shares > 0 ? dndRequest[algoIndex]?.shares : ''}
                    onChange={(e) => {
                        console.log('onchange', e.target.value);
                        setAlgoData('shares', {
                            index: algoIndex,
                            shares: Number(e.target.value)
                        })
                    }}
                    onkeydown='return (event.which >= 48 && event.which <= 57) || event.which == 8 || event.which == 46 || event.which == 37 || event.which == 39'
                />
                <span>Shares</span>
            </div>
        </div>
    )
}